export default __webpack_public_path__ + "static/ANCHOR-7-struggles-v1-15ffd6e7f328a8894bf9483b61a872c7.png";